<template>
    <div class="container value-editor">
        <div  v-if="!editingTemplate && editedElementId" class="row">
            <div class="col-12">
                <h4>Element navigation:</h4>
            </div>
            <div class="col-12 d-flex justify-content-center flex-column">
                <div class="btn-group" role="group">
                    <button type="button"
                            class="btn btn-danger btn-nav d-flex
                            align-items-center justify-content-center"
                            @click.stop="confirmAction({
                                question: 'delete this element?',
                                data: {},
                                callback: deleteElement
                            })"
                            name="parent"
                            v-if="editedElementId">
                        <icon name="icon-cph_iconset_trash_can" class="p-0" fontSize="20px"></icon>
                    </button>
                    <button type="button"
                            class="btn btn-primary btn-nav d-flex
                                   align-items-center justify-content-center"
                            @click="getSibling('prev')"
                            name="previous"
                            :disabled="isFirst"
                            v-if="editedElementId">
                        <icon name="icon-di_arow_left" class="p-0" fontSize="20px"></icon>
                    </button>
                    <button type="button"
                            class="btn btn-warning btn-nav d-flex
                                   align-items-center justify-content-center"
                            @click="getParent"
                            name="parent"
                            v-if="editedElementId">
                        <icon name="icon-di_arow_left"
                              class="p-0"
                              :rotate="true"
                              fontSize="20px" />
                    </button>
                    <button type="button"
                            class="btn btn-info btn-nav
                                    d-flex align-items-center
                                    justify-content-center"
                            @click="getChild"
                            name="child"
                            :disabled="!hasChildren"
                            v-if="editedElementId">
                        <icon name="icon-di_arow_left"
                              class="p-0"
                              :rotate="true"
                              :rotateValue="270"
                              fontSize="20px"/>
                    </button>
                    <button type="button"
                            class="btn btn-primary btn-nav d-flex
                                   align-items-center justify-content-center"
                            @click="getSibling('next')"
                            name="next"
                            :disabled="isLast"
                            v-if="editedElementId">
                        <icon name="icon-di_arow_right"
                              class="p-0"
                              fontSize="20px"/>
                    </button>
                </div>
            </div>
        </div>
        <div class="row" v-if="editedElementId && rootPath">
            <div class="col-12">
                <h4>Assigned template groups:</h4>
            </div>
            <div class="col-12">
                <div class="layout-picker mt-2" >
                    <label for="grouppicker">Choose template groups</label>
                    <multiselect v-model="editedElement.groups"
                                 :deselect-label="$t('UI.cantRemove')"
                                 track-by="label"
                                 label="label"
                                 :max-height="600"
                                 :style="{'font-size': '12px'}"
                                 :multiple="true"
                                 :option-height="20"
                                 :closeOnSelect="false"
                                 placeholder="Select template groups"
                                 id="grouppicker"
                                 @input="handleGroupSelection"
                                 :preserve-search="true"
                                 :options="templateGroups"
                                 :searchable="true"
                                 :allow-empty="true"></multiselect>
                </div>
            </div>
        </div>
        <div class="row" v-if="editedElementId">
            <div class="col-12">
                <h4>Element styles:</h4>
                <h4 class="text-danger" v-if="editedElementId === 'body'">
                    Warning you shouldn't edit this element
                </h4>
            </div>
            <div class="col-12">
                <object-value-content
                    :key="editedElementId"
                    :propName="''"
                    :path="''"
                    :element="editedElement">
                </object-value-content>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { mapGetters, mapActions, mapMutations } from 'vuex';
import ObjectValueContent from './ObjectValueContent.vue';
import TemplateObject from './templateObject.vue';
import Calculator from './calculator.vue';
import Icon from '../../../../Shared/Icons/Icon';
export default {
    name: 'ValueEditor',
    data () {
        return {
            editingTemplate: false,
            calculatorOpened: false,
            isFirst: false,
            isLast: false
        };
    },
    computed: {
        ...mapGetters({
            editedElement: 'getEditedElement',
            editedElementId: 'getEditedElementId',
            rootPath: 'getEditedElementRootPath',
            templateGroups: 'getTemplateGroups'
        }),
        hasChildren () {
            return this.editedElement && this.editedElement.children;
        }
    },
    components: {
        ObjectValueContent,
        TemplateObject,
        Calculator,
        Icon
    },
    watch: {
        editedElementId (newValue) {
            this.clearActiveElement();
            this.setActiveElement(newValue);
        }
    },
    methods: {
        ...mapMutations(['setAvailableTemplates']),
        ...mapActions([
            'getEditedElementParent',
            'getEditedElementSibling',
            'getTemplatesByGroupIds',
            'destroyElement',
            'clearEditedElement',
            'confirmAction',
            'getEditedElementChild'
        ]),
        deleteElement () {
            this.destroyElement({oldPath: this.rootPath});
            this.clearEditedElement();
            this.clearActiveElement();
        },
        clearActiveElement () {
            let element = document.querySelectorAll('.activeElement');
            if (element && element[0]) {
                element.forEach(el => {
                    el.classList.remove('activeElement');
                });
            }
        },
        setActiveElement (id) {
            if (id) {
                let element = document.getElementById(id);
                if (element) {
                    element.classList.add('activeElement');
                    this.isFirst = !element.previousSibling;
                    this.isLast = !element.nextSibling;
                }
            }
        },
        getParent () {
            this.getEditedElementParent({path: this.rootPath});
        },
        getChild () {
            this.getEditedElementChild({path: this.rootPath});
        },
        getSibling (prevOrNext) {
            this.getEditedElementSibling({path: this.rootPath, prevOrNext: prevOrNext});
        },
        handleGroupSelection (ev) {
            this.$vuexSet(`currentLayout.${this.rootPath}.groups`, ev || []);
        },
        bindKeyListeners (ev) {
            let {keyCode} = ev;
            if (keyCode) {
                switch ( keyCode ) {
                    case 37 :
                        ev.preventDefault();
                        this.getSibling('prev');
                        break;
                    case 38 :
                        ev.preventDefault();
                        this.getParent();
                        break;
                    case 39 :
                        ev.preventDefault();
                        this.getSibling('next');
                        break;
                    case 40 :
                        ev.preventDefault();
                        this.getChild();
                        break;
                    case 46 :
                        ev.preventDefault();
                        this.confirmAction({question: 'delete this element?', data: {}, callback: this.deleteElement});
                        break;
                    default: return;
                }
            }
        }
    },
    mounted () {
        window.addEventListener('keyup', this.bindKeyListeners, false);
    },
    beforeDestroy () {
        window.removeEventListener('keyup', this.bindKeyListeners, false);
    }
};
</script>

<style lang="scss">
    .delete-prop-button {
        position: absolute;
        top: 0;
        right: 0;
    }

</style>
